module.exports = __webpack_public_path__ + "img/ico-search.32467f74.png";